import { rgba } from 'polished';
import css from '@styled-system/css';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { isFunction } from './assertions.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const get = (obj, path, defaultValue = null) => {
  const result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce((res, key) => res !== null && res !== void 0 ? res[key] : res, obj);
  return result === void 0 || result === obj ? defaultValue : result;
};
const themeGet = (props, path) => {
  const value = get(props.theme, path);
  return isFunction(value) ? value(props) : value;
};
const stripUnit = (str) => parseFloat(str);
const token = (path) => (props) => themeGet(props, path);
const color = (path, opacity2 = 1) => (props) => rgba(themeGet(props, `colors.${path}`), opacity2);
const opacity = (path) => (props) => themeGet(props, `opacities.${path}`);
const palette = color;
const baseUnit = (multiplier) => ({ theme }) => theme.baseUnit(multiplier);
const spacing = (size, options) => ({ theme }) => theme.spacing(size, options);
const fontSize = (size) => (props) => themeGet(props, `fontSizes.${size}`);
const lineHeight = (size) => (props) => themeGet(props, `lineHeights.${size}`);
const fontWeight = (weight) => (props) => themeGet(props, `fontWeights.${weight}`);
const radius = (radius2) => (props) => themeGet(props, `radii.${radius2}`);
const shadow = (shadow2) => (props) => themeGet(props, `shadows.${shadow2}`);
const component = (path) => (props) => themeGet(props, `components.${path}`);
const border = (type) => (props) => themeGet(props, `borders.${type}`);
const zIndex = (zIndex2) => (props) => {
  return Number(themeGet(props, `zIndices.${zIndex2}`));
};
const breakpoint = (breakpoint2) => ({ theme }) => theme.breakpoint(breakpoint2);
const getThemeModeValue = (props, values) => {
  const mode = props && props.theme && props.theme.mode;
  const themeValue = typeof mode === "function" ? mode(values) : values[mode];
  return typeof themeValue === "function" ? themeValue(props) : themeValue;
};
const themeMode = (values) => (props) => getThemeModeValue(props, values);
const parseStyles = (styles) => (props) => {
  if (!styles) {
    return;
  }
  return Object.entries(styles).reduce((acc, [key, value]) => {
    if (typeof value === "object") {
      if (key in props && typeof props[key] === "boolean" && !!props[key]) {
        acc = __spreadValues(__spreadValues({}, acc), parseStyles(value)(props));
        return acc;
      }
      acc[key] = parseStyles(value)(props);
      return acc;
    }
    acc[key] = typeof value === "function" ? value(props) : value;
    return acc;
  }, {});
};
const extractStyles = (props, variantValues, theme) => {
  const variantStyles = typeof variantValues === "function" ? variantValues(props) : variantValues;
  const flattenedValues = parseStyles(variantStyles)(props);
  return css(flattenedValues)(theme);
};
const variant = ({ prop, compoundProp, variants }) => (props) => {
  var _a;
  const { theme } = props;
  let compiledStyles = {};
  const propValue = props[prop];
  const variantValues = variants == null ? void 0 : variants[propValue];
  const extractedStyles = extractStyles(props, variantValues, theme);
  compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles);
  if (compoundProp) {
    const compoundPropValue = props[compoundProp];
    const variantValues2 = (_a = variants == null ? void 0 : variants[propValue]) == null ? void 0 : _a[compoundPropValue];
    const extractedStyles2 = extractStyles(props, variantValues2, theme);
    compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles2);
  }
  const finalStyles = Object.entries(compiledStyles).reduce((acc, [key, value]) => {
    const x = isFunction(value) ? value(props) : value;
    acc[key] = x;
    return acc;
  }, {});
  const finalCompileStyles = css(finalStyles)(theme);
  return finalCompileStyles;
};
const useStyles = ({ styles, props }) => {
  const themeContext = useContext(ThemeContext);
  return styles(__spreadValues({ theme: themeContext }, props));
};

export { baseUnit, border, breakpoint, color, component, fontSize, fontWeight, get, lineHeight, opacity, palette, radius, shadow, spacing, stripUnit, themeMode, token, useStyles, variant, zIndex };
//# sourceMappingURL=theme.es.js.map
